import { useEffect } from "react";
import { useLocation } from "react-router-dom";

// Keeps <link rel="canonical"> and og:url pointing at the page actually being
// viewed. index.html used to hardcode both to the homepage, and since this is a
// single-page app that same file is served for every route — so every product
// and category page was telling Google "I'm a duplicate of the homepage",
// which is an instruction not to index it separately.
const SITE_ORIGIN = "https://fmartskorea.com";

function upsert(selector, create) {
  let el = document.querySelector(selector);
  if (!el) {
    el = create();
    document.head.appendChild(el);
  }
  return el;
}

export default function Canonical() {
  const { pathname } = useLocation();

  useEffect(() => {
    // Query strings are deliberately dropped. Referral links (?ref=CODE) and
    // campaign tags would otherwise make every share look like a separate
    // duplicate of the same page.
    const path = pathname.replace(/\/+$/, "") || "/";
    const url = SITE_ORIGIN + path;

    const link = upsert('link[rel="canonical"]', () => {
      const el = document.createElement("link");
      el.setAttribute("rel", "canonical");
      return el;
    });
    link.setAttribute("href", url);

    const ogUrl = upsert('meta[property="og:url"]', () => {
      const el = document.createElement("meta");
      el.setAttribute("property", "og:url");
      return el;
    });
    ogUrl.setAttribute("content", url);
  }, [pathname]);

  return null;
}
